/** DomiKids / DomiPad Accel WebView 环境识别（对齐 domi-ai-home）。 */

/** iOS / 通用容器：UA 中带独立 token `app=DomiKids` */
export function isDomiKidsAppUserAgent(userAgent: string): boolean {
  return /(?:^|[;\s])app=DomiKids(?:[\s;/]|$)/.test(userAgent);
}

function getUserAgent(): string {
  if (typeof navigator === 'undefined') return '';
  return navigator.userAgent || '';
}

/** iOS / 通用容器 */
export function isDomiKids(): boolean {
  return isDomiKidsAppUserAgent(getUserAgent());
}

/** 安卓容器：UA 中带 `DomiKidsAndroid` */
export function isDomiKidsAndroid(): boolean {
  return /DomiKidsAndroid/i.test(getUserAgent());
}

/** 当前是否为 DomiKids 原生嵌套 H5（iOS 或安卓） */
export function isDomiKidsNativeWebView(): boolean {
  return isDomiKids() || isDomiKidsAndroid();
}

/** 页面是否已注入 AccelWebView JS Bridge（不依赖 UA） */
export function hasJavascriptBridge(): boolean {
  return (
    typeof window !== 'undefined' &&
    !!(window as unknown as { WebViewJavascriptBridge?: unknown }).WebViewJavascriptBridge
  );
}

/**
 * 应按 App 内逻辑处理：DomiKids UA，或已注入 Bridge（兼容 DomiPad 等）。
 * 普通桌面/手机浏览器两者皆无。
 */
export function isNativeAppContainer(): boolean {
  return isDomiKidsNativeWebView() || hasJavascriptBridge();
}
